import React from 'react';
import { Formik, FormikConfig, FormikErrors, FormikProps } from 'formik';
import {
  Alert,
  Button,
  Box,
  Text,
  constants
 } from '@match/react-component-library';
import { RedemptionFormData, RedemptionFormProps } from './types';
import { OutlinedInput } from '../../../app-core-components';
const { SPACE, TYPOGRAPHY, FONT_WEIGHT, SEMANTIC_COLOR_NAME } = constants;

class RedemptionForm extends React.Component<RedemptionFormProps> {
  handleFormSubmit: FormikConfig<RedemptionFormData>['onSubmit'] = (values, parameters) => {
    this.props.onSubmit(values, parameters.setSubmitting);
  }

  handleValidate: FormikConfig<RedemptionFormData>['validate'] = (values) => {
    const errors: FormikErrors<RedemptionFormData> = {};

    if (!values.firstName) {
      errors.firstName = 'required';
    }
    if (!values.lastName) {
      errors.lastName = 'required';
    }
    if (!values.giftCardCode) {
      errors.giftCardCode = 'required';
    }
    if (values.giftCardCode.length !== 16) {
      errors.giftCardCode = 'must be 16 digits';
    }
    if (!values.giftCardCvv) {
      errors.giftCardCvv = 'required';
    }
    if (!values.giftCardExpirationMonth) {
      errors.giftCardExpirationMonth = 'required';
    }
    if (!values.giftCardExpirationYear) {
      errors.giftCardExpirationYear = 'required';
    }
    const month = parseInt(values.giftCardExpirationMonth);
    if (!month || month < 1 || month > 12) {
      errors.giftCardExpirationMonth = 'invalid';
    }

    const year = parseInt(values.giftCardExpirationYear);
    if (!year || year < 2000 || year > 2100) {
      errors.giftCardExpirationYear = 'invalid';
    }

    return errors;
  }

  render() {
    return (
      <Formik
        initialValues={{
          firstName: '',
          lastName: '',
          giftCardCode: '',
          giftCardCvv: '',
          giftCardExpirationMonth: '',
          giftCardExpirationYear: ''
        }}
        validate={this.handleValidate}
        validateOnChange={false}
        onSubmit={this.handleFormSubmit}
        render={(props: FormikProps<RedemptionFormData>) => {
          const { errors, handleChange, handleSubmit, isSubmitting, values } = props;
          return (
            <form onSubmit={handleSubmit} noValidate style={{width: `100%`}} >
              <Box>
                <Text
                  fontSize={TYPOGRAPHY.H1}
                  fontWeight={FONT_WEIGHT.BOLD}
                  color={SEMANTIC_COLOR_NAME.DARK}
                >
                  Put your gift card into action</Text>
              </Box>        
              {this.props.apiErrorMessage && <Box paddingY={SPACE.LARGE} >
                <Alert type='error'>{this.props.apiErrorMessage}</Alert>
              </Box>}
              <Box
                paddingY={SPACE.XLARGE}
              >
                <OutlinedInput
                  error={!!errors.giftCardCode}
                  errorMessage={errors.giftCardCode}
                  id="giftCardCode"
                  name="giftCardCode"
                  onChange={handleChange}
                  placeholder={'Card number'}
                  uia="giftCardCode"
                  value={values.giftCardCode}
                  width="100%"
                />
              </Box>
              <Box
                paddingBottom={SPACE.XLARGE}
              >
                <OutlinedInput
                  error={!!errors.firstName}
                  errorMessage={errors.firstName}
                  id="firstName"
                  name="firstName"
                  onChange={handleChange}
                  placeholder={'First name'}
                  uia="firstName"
                  value={values.firstName}
                  width="100%"
                />
              </Box>
              <Box
                paddingBottom={SPACE.XLARGE}
              >
                <OutlinedInput
                  error={!!errors.lastName}
                  errorMessage={errors.lastName}
                  id="lastName"
                  name="lastName"
                  onChange={handleChange}
                  placeholder={'Last name'}
                  uia="lastName"
                  value={values.lastName}
                  width="100%"
                />
              </Box>
              <Box
                paddingBottom={SPACE.XXXLARGE}
                display="flex"
                justifyContent="space-between"
              >
                <Box
                  width="23%"
                >
                  <OutlinedInput
                    error={!!errors.giftCardCvv}
                    errorMessage={errors.giftCardCvv}
                    id="giftCardCvv"
                    name="giftCardCvv"
                    onChange={handleChange}
                    placeholder={'CVV'}
                    uia="giftCardCvv"
                    value={values.giftCardCvv}
                    width="100%"
                  />
                </Box>
                  <Box 
                    width="37%"
                    marginRight={SPACE.SMALL} 
                    marginLeft={SPACE.SMALL}
                  >
                    <OutlinedInput
                      error={!!errors.giftCardExpirationMonth}
                      errorMessage={errors.giftCardExpirationMonth}
                      id="giftCardExpirationMonth"
                      name="giftCardExpirationMonth"
                      onChange={handleChange}
                      placeholder={'Exp. (MM)'}
                      uia="giftCardExpirationMonth"
                      value={values.giftCardExpirationMonth}
                      width="100%"
                    />
                  </Box>
                  <Box
                    width="40%"
                  >
                    <OutlinedInput
                      error={!!errors.giftCardExpirationYear}
                      errorMessage={errors.giftCardExpirationYear}
                      id="giftCardExpirationYear"
                      name="giftCardExpirationYear"
                      onChange={handleChange}
                      placeholder={'Exp. (YYYY)'}
                      uia="giftCardExpirationYear"
                      value={values.giftCardExpirationYear}
                      width="100%"
                    />
                  </Box>
              </Box>
              <Button
                disabled={isSubmitting}
                fullWidth
                onSubmit={handleSubmit as (e?: React.FormEvent<HTMLElement>) => void}
                size={'xlarge'}
                type="submit"
              >
                Submit
              </Button>
              <Box
                paddingTop={SPACE.XLARGE}
              >
                <Text
                textAlign="center"
                fontSize={TYPOGRAPHY.SMALLBODY}
                lineHeight="1.8"
                >
                  <span>Don’t have a Match gift card? <a href="https://www.match.com/subscribe">Click here </a></span>
                </Text>
                
              </Box>
            </form>
          )
        }}
      />
    );
  }
}

export default RedemptionForm;
